// East York service landing — programs tabs + FAQ accordion (single-open).
// Bundled globally into app.min.js; guarded by .tp-ey so it no-ops elsewhere.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-ey');
    if (!root) return;

    // ── Programs tabs ──
    var tabs = root.querySelectorAll('.ey-programs__tab');
    var panels = root.querySelectorAll('.ey-programs__panel');
    if (tabs.length && panels.length) {
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var idx = tab.getAttribute('data-ey-tab');
                tabs.forEach(function (t) {
                    var on = t === tab;
                    t.classList.toggle('is-active', on);
                    t.setAttribute('aria-selected', on ? 'true' : 'false');
                });
                panels.forEach(function (p) {
                    var on = p.getAttribute('data-ey-panel') === idx;
                    p.classList.toggle('is-active', on);
                    if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
                });
            });
        });
    }

    // ── Reviews slider (Swiper) ──
    if (typeof Swiper !== 'undefined') {
        root.querySelectorAll('.ey-reviews__swiper').forEach(function (el) {
            var wrap = el.closest('.ey-reviews__slider');
            new Swiper(el, {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: el.querySelectorAll('.swiper-slide').length > 3,
                autoHeight: false,
                autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true },
                navigation: {
                    nextEl: wrap.querySelector('.ey-reviews__nav--next'),
                    prevEl: wrap.querySelector('.ey-reviews__nav--prev'),
                },
                pagination: {
                    el: wrap.querySelector('.ey-reviews__dots'),
                    clickable: true,
                },
                breakpoints: {
                    576:  { slidesPerView: 2, spaceBetween: 16 },
                    900:  { slidesPerView: 3, spaceBetween: 16 },
                },
            });
        });
    }

    // ── FAQ accordion (single-open) ──
    var items = root.querySelectorAll('.ey-faq__item');
    if (items.length) {
        items.forEach(function (item) {
            var btn = item.querySelector('.ey-faq__q');
            if (!btn) return;
            btn.addEventListener('click', function () {
                var isOpen = item.classList.contains('is-open');
                items.forEach(function (other) {
                    other.classList.remove('is-open');
                    var b = other.querySelector('.ey-faq__q');
                    if (b) b.setAttribute('aria-expanded', 'false');
                });
                if (!isOpen) {
                    item.classList.add('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                }
            });
        });
    }
});
